import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import contactbg from './../../images/aboutus-bg-2.png';

export const ContactScreen = () => {
  const { t } = useTranslation(); // Hook for translations

  return (
    <>
      <Helmet>
        <title>Sonnen Raffstoren GmbH — Kontakt</title>
        <meta
          name="description"
          content="Kontaktieren Sie Sonnen Raffstoren GmbH für Beratung, Offerten und die professionelle Montage von Raffstoren, Rollläden, Markisen, Insektenschutz und maßgeschneiderter Außenbeschattung. Wir unterstützen Sie von der ersten Idee über Vor-Ort-Messungen und individuelle Planung bis zur fachgerechten Installation, Inbetriebnahme und Wartung. Unsere Systeme kombinieren Sonnen-, Blend- und Sichtschutz mit langlebigen Materialien, Korrosionsschutz und präziser Verarbeitung – geeignet für Wohn- und Gewerbeimmobilien. Optional bieten wir motorisierte Antriebe, Wind- und Sonnensensorik sowie smarte Steuerungen zur Integration in Smart-Home- und Gebäudeautomation. Wir erstellen transparente Angebote, kommunizieren realistische Liefer- und Montagezeiten und bieten zuverlässigen Service inklusive Reparaturen und regelmäßiger Inspektionen. Ob Neubau, Renovation oder Projektgeschäft mit Architekten und Bauleitern: Wir helfen, passende Beschattungsstrategien zu finden, die Überhitzung reduzieren, Tageslicht sinnvoll nutzen und den Bedarf an Klimatisierung senken. Schreiben Sie uns per E-Mail, rufen Sie an oder nutzen Sie das Kontaktformular – wir melden uns zeitnah mit den nächsten Schritten."
        />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content="Sonnen Raffstoren GmbH — Kontakt" />
        <meta
          property="og:description"
          content="Beratung, Offerten, Vor-Ort-Messung, Montage und Service für Raffstoren, Rollläden und Außenbeschattung in der Schweiz."
        />
        <meta property="og:type" content="website" />

        <html style={{ display: 'none' }}>
          Sonnen Raffstoren GmbH unterstützt Privat- und Geschäftskunden bei der
          Planung und Umsetzung moderner Außenbeschattung. Wir beraten
          persönlich, analysieren die Situation vor Ort und empfehlen passende
          Raffstoren- und Rollladenlösungen für Komfort, Sichtschutz und
          Energieeffizienz. Unser Service umfasst exakte Vermessung,
          individuelle Konfiguration von Lamellenprofilen, Farben und
          Oberflächen sowie die professionelle Montage inklusive Inbetriebnahme.
          Auf Wunsch integrieren wir elektrische Antriebe, Wind- und
          Sonnensensoren und smarte Steuerungen, damit Ihre Beschattung
          automatisch auf Wetter und Tageslicht reagiert und sich in Smart-Home-
          oder Gebäudeautomation einbinden lässt. Durch langlebige Materialien
          und geprüfte Fertigungs- und Montageprozesse stellen wir eine hohe
          Witterungsbeständigkeit und zuverlässige Bedienbarkeit sicher. Nach
          der Installation bieten wir Wartung, Reparaturen und transparente
          Garantie- und Servicebedingungen. Für Architekten, Bauleiter und
          Projektkunden koordinieren wir die Umsetzung effizient und
          termingerecht. Kontaktieren Sie uns für eine Offerte, Referenzen oder
          einen Besichtigungstermin in Romanshorn.
        </html>
      </Helmet>
      <section
        className="w-full min-h-svh flex flex-col md:flex-row justify-center items-center px-smallPx md:px-mediumPx lg:px-largePx xl:px-[200px] py-20 bg-gradient-to-b from-black to-[#1E90AA] md:bg-none"
        style={{
          ...(window.innerWidth >= 768
            ? {
                backgroundImage: `url(${contactbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'bottom',
              }
            : {}),
        }}
      >
        {/* Left Side - Contact Details */}
        <div className="w-[90%] h-fit md:w-1/2 flex flex-col justify-center text-black bg-white p-5 sm:p-10 rounded-tr-xl md:rounded-tr-none rounded-tl-xl md:rounded-bl-xl shadow-xl">
          <h1 className="text-xl md:text-3xl font-bold mb-4">
            {t('contactScreen.title')}
          </h1>
          <p className="text-md md:text-lg">{t('contactScreen.findUs')}</p>
          <p className="font-semibold">Waldmannstrasse 33, 8590 Romanshorn</p>
          <p className="font-semibold">Switzerland</p>

          <p className="mt-4">
            <span className="font-semibold">
              {t('contactScreen.phoneLabel1')}
            </span>{' '}
            <a href="tel:+41799219200" className="hover:underline">
              +41 79 921 92 00
            </a>
          </p>
          <p>
            <span className="font-semibold">
              {t('contactScreen.phoneLabel2')}
            </span>{' '}
            <a href="tel:+41788980284" className="hover:underline">
              +41 78 898 02 84
            </a>
          </p>
          <p className="mt-4">
            <span className="font-semibold">
              {t('contactScreen.emailLabel')}
            </span>{' '}
            <a
              href={`mailto:${t('contactScreen.email')}`}
              className="hover:underline"
            >
              {t('contactScreen.email')}
            </a>
          </p>

          <p className="mt-4">{t('contactScreen.availability')}</p>
        </div>

        {/* Right Side - Map */}
        <div className="w-full md:w-1/2 flex justify-center items-center z-10">
          <div className="w-[500px] h-[300px] md:w-full md:h-[400px] rounded-lg overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2692.4215359885484!2d9.370426199999999!3d47.5595862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479afd86e63b73f5%3A0x4c0e573b808a9d7b!2sSonnen%20Raffstoren%20GmbH!5e0!3m2!1sen!2smk!4v1769965200647!5m2!1sen!2smk"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactScreen;
